export const categories = ['apartment', 'commercial', 'land', 'parking', 'building', 'equipment', 'vehicle', 'other'];
export const statuses = ['retained', 'company_use', 'available_for_rent', 'rented_out'];
export const currencies = ['EUR', 'MKD', 'ALL', 'USD'];
export const emptyAsset = {
  name: '', reference: '', category: 'apartment', status: 'retained', location: '', owner_name: '',
  area_m2: '', acquisition_date: '', estimated_value: '', currency: 'EUR', monthly_rent: '',
  tenant_name: '', tenant_contact: '', lease_start: '', lease_end: '', notes: '',
};
export const assetPayload = form => Object.fromEntries(Object.keys(emptyAsset).map(key => {
  const value = form[key];
  if (['estimated_value', 'monthly_rent'].includes(key)) return [key, Number(value)];
  if (key === 'area_m2') return [key, value === '' || value == null ? null : Number(value)];
  if (['acquisition_date', 'lease_start', 'lease_end'].includes(key)) return [key, value || null];
  return [key, value];
}));
// Browser language detection may return OS locale tags such as en-US@posix.
// Limit Intl to the three supported application locales instead of passing raw tags.
export const assetLocale = language => ({ sq: 'sq-AL', mk: 'mk-MK' })[String(language).toLowerCase().split(/[-_@]/)[0]] || 'en-GB';
export const money = (value, currency, language) => new Intl.NumberFormat(assetLocale(language), { style: 'currency', currency, maximumFractionDigits: 2 }).format(value);
export const statusClasses = {
  retained: 'bg-slate-100 text-slate-700 border-slate-200',
  company_use: 'bg-blue-50 text-blue-700 border-blue-200',
  available_for_rent: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  rented_out: 'bg-indigo-50 text-indigo-700 border-indigo-200',
};